import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { Reveal } from '../ui/Reveal';
import { articles } from '../../data/services';
export function Education() {
  return <section id="educacion" className="bg-beige py-20 lg:py-32" data-id="element-118" data-mp="1lcit998bnw4m">
      <div className="mx-auto max-w-shell px-5 lg:px-10" data-id="element-119" data-mp="1pdcgs1hur8wz">
        <SectionHeader eyebrow="Educación" title={<>
              Entender tus opciones
              <br data-id="element-121" data-mp="xldekxe4b9vw" />
              <span className="text-teal" data-id="element-122" data-mp="xkvbbgt1fveh">también es parte de protegerte.</span>
            </>} data-id="element-120" data-mp="1pexbps82wtvd" />

        <div className="mt-14 grid gap-6 lg:grid-cols-3 lg:gap-7" data-id="element-123" data-mp="11m76e1uol8u2">
          {articles.map((a, i) => <Reveal key={a.title} delay={i * 0.08} className="h-full" data-id="element-124" data-mp="16n4ipxt0f8nn" data-mpi={i}>
              <article className="group flex h-full flex-col rounded-[24px] border border-navy/[0.06] bg-cream p-8 transition-[transform,box-shadow] duration-300 ease-out hover:-translate-y-1 hover:shadow-lift" data-id="element-125" data-mp="2d2x5l10ot0e6">
                <span className="eyebrow text-gold" data-id="element-126" data-mp="2gt8gk0mgm3cb">{a.topic}</span>
                <h3 className="mt-5 font-display text-[19px] font-semibold leading-snug text-navy" data-id="element-127" data-mp="2bvgdqbka0wtc">
                  {a.title}
                </h3>
                <p className="mt-4 flex-1 text-[14px] font-light leading-relaxed text-ink/65" data-id="element-128" data-mp="26uix43ex0aty">
                  {a.description}
                </p>
                <a href="#agenda" className="mt-8 inline-flex items-center gap-2 font-display text-[11.5px] font-semibold tracking-[0.12em] text-teal" data-id="element-129" data-mp="1xv5mh7f21g7n">
                  LEER MÁS
                  <ArrowUpRightIcon size={15} className="transition-transform duration-200 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-130" data-mp="1o6nosz22np88" />
                </a>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}